import { createContext } from 'react'
import BasePageModel from '../types/BasePageModel'

const PageModelContext = createContext<BasePageModel | null>(null)

export default PageModelContext
